import { render } from "./ZodiacReference.vue?vue&type=template&id=7cc570c1"
import script from "./ZodiacReference.vue?vue&type=script&lang=js"
export * from "./ZodiacReference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__